export enum PlatformType {
  WEB = 'WEB'
}
